
import aboutimg from "../images/about01.png"
import aboutimg01 from "../images/about101.png"
import PrimaryBtn from "../component/btn/PrimaryBtn";
import box from "../images/hover-img/cut-img-box.png"
import AboutSlider from "../component/slider/AboutSlider";
import about02 from "../images/about02.png"
import star from "../images/icon/Star.png"
import Client from "../component/Client";
import MainTestimonial from "../component/slider/MainTestimonial"
import Blog from "../component/Blog";
import Cta from "../component/Cta";
import { Helmet } from "react-helmet";
export default function About() {
    return (
        <div>
          <Helmet>
            <title>ParcelX - About</title>
          </Helmet>
            <section className="section01 about-padding">
              <div className="container-fluid">
                <div className="col-md-11 mx-auto mt-5">
                  <div className="row">
                    <div className="col-lg-5 col-md-5 order-md-5">
                      <div className="image-box">
                        <img src={aboutimg} className="img-fluid cut-img d-lg-block d-none" />
                        <img src={aboutimg01} className="img-fluid d-lg-none d-block" />                        
                        <img src={box} className="img-box d-lg-block d-none" />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-7">
                      <div className="about-content">
                        <h2 className="heading about-heading">Our Story: The Journey That Shaped Our <span className="img-span">Success...</span></h2>
                        <div className="black-box">
                          <h4>50K+</h4>
                          <p>Businesses use<br/> our Superpowers</p>
                        </div>
                        <div className="row">
                          <div className="col-md-10">
                            <p>At ParcelX, we are redefining logistics by creating a seamless, technology-driven platform that empowers businesses to ship smarter, faster, and with complete confidence.</p>
                          </div>
                        </div>
                        <PrimaryBtn text="Get Started" href="https://seller.parcelx.in/register" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section03">
              <div className="container-fluid">
                <div className="col-md-11 mx-auto">
                  <AboutSlider />
                </div>
              </div>
            </section>
            <section className="section03">
              <div className="container-fluid">
                <div className="col-md-11 mx-auto">
                  <div className="row align-items-center">
                    <div className="col-md-5 order-md-2">
                      <img src={about02} className="img-fluid mb-3" />
                      <div className="black-box d-block">
                        <img src={star} className="img-fluid mb-3" />
                        <p>4.9/5 Ratings from Sellers</p>
                      </div>
                    </div>
                    <div className="col-md-7">
                      <h2 className="heading"><span>Our Vision & Mission:</span> Know more about ParcelX</h2>
                      <p className="f-24 fw-500">Our Vision</p>
                      <p className="f-16">We assist expanding organisations manage increasing demand and expectations for faster deliveries. We help them maximize customer satisfaction by providing a comprehensive solution to get their products safely to their customers.</p>
                      <div className="border"></div>
                      <p className="f-24 fw-500">Our Mission</p>
                      <p className="f-16">We aim to achieve meaningful success by offering speedy and cost-effective solutions to our clients. By tapping new markets, we strive to provide lower system investment and significantly reduce logistics costs.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <Client />
            <MainTestimonial />
            {/* <Blog /> */}
            <Cta />
        </div>
    );
}
